<template lang="html">
  <div class="topContents js-top_contents">
    <Members />
  </div>
</template>

<script>
import Members from "./Members/_index.vue";

export default {
  components: {
    Members
  },
  computed: {},
  methods: {
    layout() {
      const wrapper = document.querySelector(".js-wrapper");
      const contents = document.querySelector(".js-top_contents");
      const footer = document.querySelector(".footer");
      const block = document.querySelector(".js-block");

      contents.style.minHeight = `${window.innerHeight -
        (block.clientHeight +
          parseInt(getComputedStyle(wrapper).padding) * 2 +
          footer.clientHeight +
          parseInt(getComputedStyle(footer).marginTop))}px`;
    }
  },
  mounted() {
    this.layout();
    window.addEventListener("resize", this.layout);
  },
  beforeDestroy: function() {
    window.removeEventListener("resize", this.layout);
  }
};
</script>

<style lang="scss" scoped>
.topContents {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  box-sizing: border-box;
  width: 100%;
  -ms-overflow-style: none;
  scrollbar-width: none;

  // min-height: calc(100vh - 150px);

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TOP/contents/_index.vue